module.exports = __webpack_public_path__ + "img/vietnam.6b38229d.svg";